<div class="p-3">
  <form [formGroup]="contentFilters">
    <mat-form-field class="w-full" [floatLabel]="'never'" appearance="outline">
      <input matInput placeholder="Headline" formControlName="headline" />
    </mat-form-field>

    <mat-expansion-panel class="mat-elevation-z0" hideToggle>
      <mat-expansion-panel-header
        [expandedHeight]="'25px'"
        [collapsedHeight]="'25px'"
        class="p-0"
      >
        <a><i class="icon icon-chevron-down"></i> Show advanced filters</a>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="flex flex-wrap pt-2">
          <mat-form-field
            class="w-full basis-[49%] flex-1 max-w-[49%]"
            [floatLabel]="'never'"
            appearance="outline"
          >
            <input
              type="text"
              matInput
              placeholder="Search authors..."
              [formControl]="selectedAuthorName"
              [matAutocomplete]="autoAuthor"
            />
            <button
              type="button"
              mat-button
              matSuffix
              *ngIf="selectedAuthorName.value"
              mat-icon-button
              aria-label="Clear"
              (click)="clearAuthorNameValue()"
            >
              <mat-icon>close</mat-icon>
            </button>

            <mat-autocomplete
              #autoAuthor="matAutocomplete"
              [displayWith]="displayAuthorNames"
              (optionSelected)="getSelectedAuthorOption($event.option.value.id)"
            >
              <mat-option *ngFor="let author of authors" [value]="author">
                {{ author.name }}
              </mat-option>
              <mat-option
                disabled
                *ngIf="
                  !this.authors?.length &&
                  this.selectedAuthorName.value &&
                  !this.isLoading
                "
              >
                No authors
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <span class="flex-1"></span>

          <div class="flex flex-wrap basis-[49%]">
            <mat-form-field
              [floatLabel]="'never'"
              appearance="outline"
              class="basis-[49%] flex-1 max-w-[49%]"
            >
              <input
                matInput
                [matDatepicker]="from"
                placeholder="From"
                (click)="from.open()"
                formControlName="publishDateFrom"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="from"
              ></mat-datepicker-toggle>
              <mat-datepicker #from></mat-datepicker>
            </mat-form-field>
            <span class="flex-1"></span>
            <mat-form-field
              [floatLabel]="'never'"
              appearance="outline"
              class="basis-[49%] flex-1 max-w-[49%]"
            >
              <input
                matInput
                [matDatepicker]="to"
                placeholder="To"
                (click)="to.open()"
                formControlName="publishDateTo"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="to"
              ></mat-datepicker-toggle>
              <mat-datepicker #to></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="contentFilters.hasError('publishDateRangeError')"
              >Published date range is wrong
            </mat-error>
          </div>
        </div>

        <div class="flex flex-wrap pt-2">
          <mat-form-field
            class="w-full"
            [floatLabel]="'never'"
            appearance="outline"
          >
            <input
              type="text"
              matInput
              placeholder="Search content lists..."
              [formControl]="selectedContentListName"
              [matAutocomplete]="auto"
            />
            <button
              type="button"
              mat-button
              matSuffix
              *ngIf="selectedContentListName.value"
              mat-icon-button
              aria-label="Clear"
              (click)="clearContentListNameValue()"
            >
              <mat-icon>close</mat-icon>
            </button>

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayContentListNames"
              (optionSelected)="
                getSelectedContentListOption($event.option.value.id)
              "
            >
              <mat-option
                *ngFor="let contentList of options"
                [value]="contentList"
              >
                {{ contentList.name }}
              </mat-option>
              <mat-option
                disabled
                *ngIf="
                  !this.options?.length &&
                  this.selectedContentListName.value &&
                  !this.isLoading
                "
              >
                No content
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </form>
</div>
